



































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import EspecialidadeModel from "@/models/cadastros/saude/EspecialidadeModel";
import { tiposRamoList } from "@/models/cadastros/saude/RamoModel";
import { tiposAtendimentoList } from "@/models/cadastros/saude/TipoAtendimentoModel";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { PaginationModel } from "@/models/commons/PaginationModel";
import EspecialidadeFiltro from "@/models/cadastros/saude/EspecialidadeFiltro";
import { saudeEspecialidadeService } from "@/service/cadastro/saude/especialidade/SaudeEspecialidadeService";
import MessageDialog from "@/components/modal/MessageDialog.vue";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    MessageDialog,
  },
})
export default class ListaEspecialidades extends Vue {
  $refs!: {
    filtroObserver: InstanceType<typeof ValidationObserver>;
  };

  especialidadeFiltro: EspecialidadeModel = {};

  especialidades: EspecialidadeModel[] = [];

  especialidade: EspecialidadeModel = {};

  tiposRamo = tiposRamoList;
  tiposAtendimento = tiposAtendimentoList;

  loading = false;

  openDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  dialogStyle = "";
  dialogType = "";
  exclusaoDialog = false;

  filtro: EspecialidadeFiltro = {
    nome: "",
    tipoAtendimento: undefined,
    ramo: undefined,
    options: {
      page: 1,
      itemsPerPage: 5,
      itemsLength: 0,
    },
  };
  cabecalho = [
    { text: "Atendimento", value: "ramo", width: "13%" },
    { text: "Tipo atendimento", value: "tipoAtendimento", width: "13%" },
    { text: "Nome", value: "nome" },
    { text: "Orientações", value: "orientacaoPreparo", width: "35%" },
    { text: "Ações", value: "actions", sortable: false, width: "15%" },
  ];

  pesquisar() {
    this.$refs.filtroObserver.validate().then((valid) => {
      if (valid) {
        if (this.filtro.options && this.filtro.options?.page != 1) {
          this.filtro.options.page = 1;
        } else {
          this.getData();
        }
      }
    });
  }

  getData() {
    saudeEspecialidadeService.pesquisar(this.filtro).then((res: any) => {
      this.especialidades = res.content;
      if (this.filtro.options) {
        this.filtro.options.itemsLength = res.totalElements;
      }
    });
  }

  @Watch("filtro.options.page")
  @Watch("filtro.options.itemsPerPage")
  handlePagination() {
    this.getData();
  }

  especialidadeExclusao: EspecialidadeModel = {};
  excluirEspecialidade(especialidade: EspecialidadeModel) {
    this.especialidadeExclusao = especialidade;
    this.exclusaoDialog = true;
  }

  excluir() {
    if (this.especialidadeExclusao?.id) {
      saudeEspecialidadeService.deletar(this.especialidadeExclusao?.id).then(
        (res) => {
          this.dialogTitle = "Sucesso";
          this.dialogMessage = "Especialidade excluída com sucesso.";
          this.dialogStyle = "success";
          this.openDialog = true;
          this.exclusaoDialog = false;
          this.getData();
        },
        (err) => {
          this.dialogTitle = "Erro";
          this.dialogMessage = err;
          this.dialogStyle = "error";
          this.openDialog = true;
        }
      );
    }
  }
}
